<template>
	<div class="app-container">
		<div class="filter-container">
			<h3>{{ dateTitle }} 每日明细</h3>
			<el-button
				type="primary"
				size="small"
				@click="exportData"
				style="margin-left: 20px"
			>
				导出数据
			</el-button>
		</div>

		<el-table
			v-loading="loading"
			border
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="cellStyle"
			style="width: 100%; margin-top: 20px"
		>
			<el-table-column label="排名" width="80px">
				<template slot-scope="scope">
					<span
						class="rank-badge rank-default"
						:class="{
							'rank-first': scope.$index === 0,
							'rank-second': scope.$index === 1,
							'rank-third': scope.$index === 2
						}"
					>
						{{ (currentPage - 1) * pageSize + scope.$index + 1 }}
					</span>
				</template>
			</el-table-column>
			<el-table-column 
				label="标题" 
				min-width="300px" 
				prop="title"
			>
				<template slot-scope="scope">
					<a
						:href="scope.row.url"
						target="_blank"
						class="link-style"
					>
						{{ scope.row.title || scope.row.url }}
					</a>
				</template>
			</el-table-column>
			<el-table-column prop="pv" label="PV" width="100px"> </el-table-column>
			<el-table-column prop="pv_web" label="PV-Web" width="100px">
			</el-table-column>
			<el-table-column prop="pv_h5" label="PV-H5" width="100px">
			</el-table-column>
			<el-table-column prop="pv_app" label="PV-APP" width="100px">
			</el-table-column>
			<el-table-column prop="uv" label="UV" width="100px" class-name="uv-column" header-class-name="uv-column"> </el-table-column>
			<el-table-column prop="uv_web" label="UV-Web" width="100px" class-name="uv-column" header-class-name="uv-column">
			</el-table-column>
			<el-table-column prop="uv_h5" label="UV-H5" width="100px" class-name="uv-column" header-class-name="uv-column">
			</el-table-column>
			<el-table-column prop="uv_app" label="UV-APP" width="100px" class-name="uv-column" header-class-name="uv-column">
			</el-table-column>
		</el-table>

		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="currentPage"
			:page-sizes="[20, 50, 100]"
			:page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total"
			style="margin-top: 20px; text-align: right"
		>
		</el-pagination>
	</div>
</template>

<script>
import { getDailyDetailPvuv } from "@/api/data";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default {
	name: "DailyDetail",
	data() {
		return {
			loading: false,
			tableData: [],
			currentPage: 1,
			pageSize: 20,
			total: 0,
			date: "",
			dateTitle: "",
		};
	},
	created() {
		this.date = this.$route.query.date || "";
		this.dateTitle = this.date;
		if (this.date) {
			this.getData();
		}
	},
	methods: {
		getData() {
			this.loading = true;
			getDailyDetailPvuv({
				date: this.date,
				page: this.currentPage,
				size: this.pageSize,
			})
				.then((res) => {
					this.loading = false;
					if (res.code === 200) {
						this.tableData = res.data.data || [];
						this.total = res.data.total || 0;
					} else {
						this.$message.error(res.message || "获取数据失败");
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取数据失败");
				});
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1;
			this.getData();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getData();
		},
		cellStyle({ column }) {
			if (column.property === 'url' || column.property === 'title') {
				return { 'text-align': 'left' };
			}
			return { 'text-align': 'center' };
		},
		exportData() {
			const loading = this.$loading({
				lock: true,
				text: "正在导出数据，请稍候...",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});

			// 请求所有数据（不分页）
			getDailyDetailPvuv({
				date: this.date,
				page: 1,
				size: 999999, // 获取所有数据
			})
				.then((res) => {
					if (res.code === 200) {
						const allData = res.data.data || [];

						if (allData.length === 0) {
							this.$message.warning("没有数据可导出");
							loading.close();
							return;
						}

						try {
							// 转换数据格式
							const exportData = allData.map((item, index) => ({
								排名: index + 1,
								标题: item.title || item.url,
								链接: item.url,
								PV: item.pv,
								"PV-Web": item.pv_web,
								"PV-H5": item.pv_h5,
								"PV-APP": item.pv_app,
								UV: item.uv,
								"UV-Web": item.uv_web,
								"UV-H5": item.uv_h5,
								"UV-APP": item.uv_app,
							}));

							// 创建工作簿
							const wb = XLSX.utils.book_new();
							const ws = XLSX.utils.json_to_sheet(exportData);
							XLSX.utils.book_append_sheet(wb, ws, "每日明细");

							// 生成文件
							const wbout = XLSX.write(wb, {
								bookType: "xlsx",
								bookSST: true,
								type: "array",
							});

							// 保存文件
							FileSaver.saveAs(
								new Blob([wbout], { type: "application/octet-stream" }),
								`${this.date}_每日明细.xlsx`
							);

							this.$message.success(`导出成功！共导出 ${allData.length} 条数据`);
						} catch (error) {
							console.error("导出错误:", error);
							this.$message.error("导出失败，请重试");
						} finally {
							loading.close();
						}
					} else {
						loading.close();
						this.$message.error(res.message || "获取数据失败");
					}
				})
				.catch((err) => {
					loading.close();
					console.error("导出错误:", err);
					this.$message.error("导出失败，请重试");
				});
		},
	},
};
</script>

<style scoped>
.app-container {
	padding: 20px;
}
.filter-container {
	display: flex;
	align-items: center;
}
.pointer {
	cursor: pointer;
	color: #409eff;
}
.pointer:hover {
	text-decoration: underline;
}
.link-style {
	color: #409eff;
	text-decoration: underline;
	cursor: pointer;
}
.link-style:hover {
	color: #66b1ff;
}
.rank-badge {
	display: flex;
	min-width: 30px;
	height: 30px;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	color: white;
	font-size: 14px;
	font-weight: bold;
	margin: 0 auto;
}
.rank-default {
	background: gray;
}
.rank-first {
	background: red !important;
}
.rank-second {
	background: rgb(255, 104, 70) !important;
}
.rank-third {
	background: rgb(234, 192, 25) !important;
}
</style>

<style>
/* UV 列灰色背景 - 使用全局样式以提高优先级 */
.el-table .uv-column {
	background-color: #f5f7fa !important;
}
</style>
